module.exports = __webpack_public_path__ + "media/src/images/mv-612b7c7c66b0efa4ff0dd7ecb2718bf9.png";